import { withHandlers, compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import { pushWithQuery as push } from 'utils/routing';
import { pagesMap } from 'redux/modules/traffic-common/effects';

import {
  getDriverInfoIsLoading,
  getDriverInfoIsAssigning,
  getDriverInfoData,
  getDriverInfoPositionData,
  getDriverInfoAssignDone,
  getDriverInfoAssignError,
} from 'redux/modules/journey-map/selectors';

import { assignDriver } from 'redux/modules/journey-map/effects';

import DriverInfo from './component';

const enhance = compose(
  connect(
    (state) => ({
      driver: getDriverInfoData(state),
      positionData: getDriverInfoPositionData(state),
      isLoading: getDriverInfoIsLoading(state),
      isAssigning: getDriverInfoIsAssigning(state),
      isDone: getDriverInfoAssignDone(state),
      isError: getDriverInfoAssignError(state),
    }),
    { assignDriver }
  ),
  withProps(({ driver, positionData }) => ({
    vehicles: (driver && driver.vehicles) || [],
    carrier: (driver && driver.carrier) || {},
    timestamp: positionData && positionData.timestamp,
    locationMode: positionData && positionData.locationMode,
  })),
  withHandlers({
    openCarrierPage:
      ({ carrier }) =>
      () => {
        push(pagesMap.carrier({ carrier_id: carrier.id }));
      },
    handleAssignment:
      ({ assignDriver, driver }) =>
      () => {
        assignDriver(driver.id);
      },
  })
);

export default enhance(DriverInfo);
